import { stringField, numberField } from 'common/utils/form/fieldTypes';

export default {
  name: stringField({ required: true }),
  description: stringField({ required: true }),
  multiplier: numberField({
    transformOnLoad: value =>
      parseFloat(value).toLocaleString('en', {
        maximumFractionDigits: 9
      })
  }),
  start_day: stringField({ required: true }),
  start_time: stringField({ required: true, initialValue: '00:00' }),
  end_day: stringField({ required: true }),
  end_time: stringField({ required: true, initialValue: '00:00' })
};
